import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import Typography from '@lib/components/Typography/Typography';
import styles from './NewBadge.module.scss';

export type NewBadgeColor = 'violet' | 'blue' | 'light';

export interface NewBadgeProps {
  /** Additional class name for styling */
  className?: string;
  /** Color variant of the badge */
  color?: NewBadgeColor;
}

/**
 * Badge component to indicate recently updated items.
 * Shows "New" label with gradient styling.
 * Should only be visible on default home page.
 *
 * Color variants:
 * - violet: Purple gradient with white text (default)
 * - blue: Blue gradient with white text
 * - light: Light blue/white gradient with blue text
 */
export default function NewBadge({
  className,
  color = 'violet',
}: NewBadgeProps) {
  const { t } = useTranslation();

  return (
    <div className={classNames(styles.badge, styles[color], className)}>
      <Typography variant="caption" component="label" className={styles.label}>
        {t('new')}
      </Typography>
    </div>
  );
}
